



import React from "react";
import '../css-coding/pricing.css';



const Pricing = () => {
  return (
    <section className="pricing-section">

      <div className="pricing-header">
        <h2 className="pricing-title">Choose the Plan Built for Your <span className="growth-text" >Growth</span></h2>
        </div>
       

     
      <div className="pricing-wrapper">
  

      

        {/* Starter */}
        <div className="card">
          <div className="card-top">
            <p className="plan-label">Starter</p>
            <h2 className="price">Starts from ₹1000</h2>

            <button className="btn light"   onClick={() => window.open("https://itsprakashhere.framer.website/", "_blank")}>Start as Starter</button>
          </div>

          <div className="divider"></div>

          <ul className="features">
            <li>Rough Cut</li>
            <li>Basic Text Caption</li>
            <li>Basic Color Grade</li>
            <li>CTA Animation</li>
            <li>Lower Third Animation</li>
            <li>Relatable BRoll Elements</li>
            <li>Image Elements</li>
            <li>Only One Revision</li>
          
          </ul>
        </div>

        {/* Pro */}
        <div className="card pro">
          <div className="card-top">
            <p className="plan-label blue">Pro</p>
            <h2 className="price blue-text">Starts from ₹1200</h2>
          

            <button className="btn blue"   onClick={() => window.open("https://itsprakashhere.framer.website/", "_blank")} > Start as Pro </button>
          </div>

          <div className="divider"></div>

          <ul className="features blue-list">
            <li>Everything from Starter</li>
            <li>Advanced Text Caption</li>
            <li>Infographic Animations</li>
            <li>Outro Logo Animation (if)</li>
            <li>Most Relatable BRoll Elements</li>
            <li>Advanced Color Grade</li>
            <li>Advanced Transitions</li>
            <li>Two or More Revision (Per Video)</li>
            <li>Most Relatable BGM, Sound Effects</li>
           
          </ul>
        </div>

        {/* Team */}
        <div className="card">
          <div className="card-top">
            <p className="plan-label">Advanced</p>
            <h2 className="price">Starts from ₹1500</h2>
         

            <button className="btn light"   onClick={() => window.open("https://itsprakashhere.framer.website/", "_blank")}>Start as Advanced</button>
          </div>

          <div className="divider"></div>

          <ul className="features">
            <li>Everything from Pro</li>
            <li>Top Engaging Text Animations</li>
            <li>3D Scene Elements</li>
            <li>Advanced Motion Graphics</li>
            <li>Advanced Color Grading</li>
            <li>Two or More Revisions (Per Video)</li>
            <li>Dual or Three Cam Edit (Podcast)</li>
            <li>Most Relatable BRoll Elements</li>
            <li>Grammer Accuracy Check (Subtitles)</li>
          </ul>
        </div>

      </div>
    </section>
  );
};

export default Pricing;